import { useCallback, useState } from 'react';

import {
  EmployeeCollaborationTask,
  EmployeeCollaborationTaskList,
} from '~/data/collaboration';
import {
  WorklistFormData,
  convertWorklistToEditWorklistData,
} from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable/EditWorklistDialog/data';
import {
  WorklistTaskFormData,
  convertWorklistTaskToEditTaskData,
} from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable/EditWorklistTaskDialog/data';

export const useWorklistTableTaskEditing = () => {
  // Worklist editing
  const [selectedWorklist, setSelectedWorklist] = useState<
    WorklistFormData | undefined
  >();

  const onCloseWorklistEdit = useCallback(() => {
    setSelectedWorklist(undefined);
  }, [setSelectedWorklist]);

  const onEditWorklist = useCallback(
    (worklist: EmployeeCollaborationTaskList) => {
      setSelectedWorklist(convertWorklistToEditWorklistData(worklist));
    },
    [setSelectedWorklist],
  );

  // Task editing
  const [selectedTask, setSelectedTask] = useState<
    WorklistTaskFormData | undefined
  >();

  const onCloseTaskEdit = useCallback(() => {
    setSelectedTask(undefined);
  }, [setSelectedTask]);

  const onEditTask = useCallback(
    (task: EmployeeCollaborationTask) => {
      setSelectedTask(convertWorklistTaskToEditTaskData(task));
    },
    [setSelectedTask],
  );

  const onAddTask = useCallback((taskData: WorklistTaskFormData) => {
    setSelectedTask(taskData);
  }, []);

  return {
    worklistEditing: {
      isEditWorklistDialogOpen: !!selectedWorklist,
      selectedWorklist,
      onCloseWorklistEdit,
      onEditWorklist,
    },
    taskEditing: {
      isEditTaskDialogOpen: !!selectedTask,
      selectedTask,
      onCloseTaskEdit,
      onEditTask,
      onAddTask,
    },
  };
};
